import React from 'react';
import { classnames } from 'helpers/utils';
import { CiteType } from 'types/common';
import * as styles from './source-cite.module.scss';

interface SourcesProps {
  cite: CiteType
  className?: string
}

export const SourceCite = ({ cite, className }: SourcesProps) => {
  if (!cite) return null;
  const dateAccessed = cite.dateaccessed && new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(cite.dateaccessed));

  return (
    <div className={classnames(className || '', styles.citeContainer)}>
      <p className={styles.citeHeader}>
        {cite.title}
        <em className={styles.webSiteName}>{cite.websitename}</em>
      </p>
      <p className={styles.availableAt}>Available at:</p>
      <a className={styles.citeUrl} href={cite.url} target="_blank" rel="noreferrer">{cite.url}</a>
      <p className={styles.citeDate}>
        {dateAccessed}
        .
      </p>
    </div>
  );
};
